// 富文本点击图片预览指令
import Vue from 'vue'
import ImgViewer from '../components/Public/ImgViewer.vue'
const ImgViewerConstructor = Vue.extend(ImgViewer)

export default {
  bind (el, {value}) {
    const _ImgViewer = new ImgViewerConstructor({})
    let vm = _ImgViewer.$mount()
    document.body.appendChild(vm.$el)
    el.addEventListener('click', ev => {
      vm.setImgBigger(ev)
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/imgViewer.js